const FEEDBACK_FIELDS = `
  items {
    ItemId
    CreatedDate
    CreatedBy
    message
    resolved
  }
`;

// `CreatedBy` is selected only so a caller can filter to one member's own
// submissions via `where` (see useMyWikiFeedback) — it must never be
// rendered, so every submission still displays as anonymous.
//
// Every submission for the wiki as a whole (not scoped to any one article),
// newest first. `where: {}` gives the admin view (all submissions); a
// `CreatedBy` filter narrows it to one member's own.
export const GET_ALL_WIKI_FEEDBACK_QUERY = `
  query GetAllWikiFeedback(
    $where: wikifeedbackFilterInput
    $order: [DynamicSortInput!]
    $pageNo: Int!
    $pageSize: Int!
  ) {
    getwikifeedbacks(
      where: $where
      order: $order
      paging: { pageNo: $pageNo, pageSize: $pageSize }
    ) {
      totalCount
      ${FEEDBACK_FIELDS}
    }
  }
`;

export const INSERT_WIKI_FEEDBACK_MUTATION = `
  mutation InsertWikiFeedback($input: wikifeedbackInsertInput!) {
    insertwikifeedback(input: $input) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const UPDATE_WIKI_FEEDBACK_RESOLVED_MUTATION = `
  mutation UpdateWikiFeedbackResolved(
    $itemId: String!
    $resolved: Boolean!
  ) {
    updatewikifeedback(
      where: { ItemId: { eq: $itemId } }
      input: { resolved: $resolved }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;
